import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { getClienteById } from '../../helpers/api_helper';

const useObtenerClienteById = (id, refresh = 0) => {
    const [cliente, setCliente] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const tenantId = useSelector((state) => state.Context.tenantId);

    useEffect(() => {
        const fetchCliente = async () => {
            if (!id || !tenantId) return;

            setLoading(true);
            setError(null);
            try {
                const response = await getClienteById(id, { tenantId });
                console.log('Response from API for cliente by id:', response);
                setCliente(response);
            } catch (err) {
                const errorMessage = `Failed to fetch cliente: ${err.message || 'Unknown error'}`;
                setError(errorMessage);
                console.error(errorMessage);
                setCliente(null);
            } finally {
                setLoading(false);
            }
        };

        fetchCliente();
    }, [id, tenantId, refresh]);

    return { cliente, loading, error };
};

export default useObtenerClienteById;